import { Button as MUIButton, ButtonProps } from '@mui/joy'

export const Button = (props: ButtonProps) => {
  return (
    <MUIButton variant="soft" {...props}>
      {props.children}
    </MUIButton>
  )
}
